import { useState, useEffect } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import RegiondoBookingCardBase from '../common/RegiondoBookingCardBase';
import useBooking from '../../../../hooks/useBooking';

function BookingCardPaintball({ booking, updateBookingState, slotMode, renderAvailableSlots }) {
  const { updateBooking } = useBooking();
  const { _id, pbSpecific, participantCount } = booking;

  const [teamColor, setTeamColor] = useState('#ffffff');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const colorCalc = id => {
    switch (id) {
      case 0:
        return '#e88935';
      case 1:
        return '#32a852';
      case 2:
        return '#4c5ad4';
      case 3:
        return '#db2acf';
      default:
        return '#ffffff';
    }
  };

  useEffect(() => {
    if (pbSpecific?.playerGroupID !== undefined) {
      setTeamColor(colorCalc(pbSpecific.playerGroupID));
    }
  }, [pbSpecific]);

  const handleClick = e => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const updatePlayerGroupID = async newId => {
    const update = { pbSpecific: { playerGroupID: newId } };
    const result = await updateBooking(_id, update);
    setTeamColor(colorCalc(result.pbSpecific.playerGroupID));
    updateBookingState(_id, result);
    handleClose();
  };

  const menuItems = [
    { id: 0, label: 'Orange', color: 'orange' },
    { id: 1, label: 'Green', color: 'green' },
    { id: 2, label: 'Blue', color: 'blue' },
    { id: 3, label: 'Pink', color: 'deeppink' },
  ];

  return (
    <RegiondoBookingCardBase
      booking={booking}
      color={teamColor}
      renderAvailableSlots={renderAvailableSlots}
      topOffset={slotMode ? 112 : 40}
      iconProps={{ participantCount, slotMode, color: teamColor, onGreaterThanClick: handleClick }}
    >
      {slotMode && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={e => {
            if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
            handleClose();
          }}
        >
          {menuItems.map(mi => (
            <MenuItem
              key={mi.id}
              sx={{ color: mi.color, fontWeight: 'bold' }}
              onClick={e => {
                e.stopPropagation();
                updatePlayerGroupID(mi.id);
              }}
            >
              {mi.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </RegiondoBookingCardBase>
  );
}

export default BookingCardPaintball;
